import React from 'react';
import { matchPath } from 'react-router-dom';
import { Modal, ButtonGroup, Button, Icon } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { routes } from 'constants/config';
import { useToggle, useAutoFocus } from 'hooks';

const match = () =>
  matchPath(window.location.pathname, { path: '/lessons/:lessonId' });

const ScormCopyContentModal = () => {
  const lessonId = match()?.params?.lessonId;
  const [modalVisible, toggleModalVisible] = useToggle();
  const autoFocus = useAutoFocus();

  return (
    <>
      <div
        onClick={toggleModalVisible}
        onKeyDown={e => e.key === 'Enter' && toggleModalVisible()}
        tabIndex="0"
        role="button"
        className="PanelToolbar-link"
      >
        <span data-display="busy" />
        <Icon name="copy" />
        {t('actions.copy_content')}
      </div>
      {modalVisible && (
        <Modal
          className="ScormCopyContentModal"
          modalWrapperClassName="ScormCopyContentModal-background"
          shown={modalVisible}
          onDismiss={toggleModalVisible}
          enableFloatingDismiss
        >
          <div className="ScormCopyContentModal-content">
            <h3 className="ModalTakeover-title">
              {t('actions.copy_content_modal.modal_title')}
            </h3>
            <Text variant={TEXT_VARIANTS.BODY}>
              {t('actions.copy_content_modal.modal_body')}
            </Text>
            <ButtonGroup alignEnd className="mt-32">
              <Button ref={autoFocus} onClick={toggleModalVisible}>
                {t('common.cancel')}
              </Button>
              <Button
                primary
                onClick={toggleModalVisible}
                url={routes.LESSON_OVERVIEW.CLONE_LESSON(lessonId)}
                data-method="post"
                data-remote="true"
                data-behavior="clone_lesson"
              >
                {t('actions.clone_lesson')}
              </Button>
            </ButtonGroup>
            <button
              className="ModalTakeover-closeButton u-resetBtn"
              onClick={toggleModalVisible}
              type="button"
            >
              <Icon name="error" />
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ScormCopyContentModal;
